import { render, staticRenderFns } from "./Prazo.vue?vue&type=template&id=4a25aa38&lang=pug&"
import script from "./Prazo.vue?vue&type=script&lang=js&"
export * from "./Prazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports